import BlankBill from "../blankbill";
import { connect } from "react-redux";
import React, { Component } from "react";
import TableBill from "../../tableProvider/table-bill";
import { getBills, getTotalElements } from "../../../../Redux/reducer/bills";
import {
  getBillsList,
  clearBillsList,
} from "../../../../Redux/actions/billActions";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import { getSessionCountry } from "../../../../Redux/reducer/session";
import { withTranslation } from "react-i18next";
import { handleWorkingHours } from "../../../utils/utilities";
import {
  getUserHolidayByCountry,
  workingHoursHandler,
} from "../../../../Redux/actions/userActions";
import {
  getHolidayStatus,
  getHolidaysByCountry,
  getisWithinWorkingHours,
} from "../../../../Redux/reducer/users";

export class PaidRejectedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: 10,
      filters: [{ property: "status", operator: "eq", value: "PAID_REJECTED" }],
      componentReady: false,
    };
  }

  handleWorkingHours = (statusOk) => {
    const { countryCode, holidaysByCountryCode } = this.props;

    const isWithinWorkingHours =
      holidaysByCountryCode?.isHoliDay || !statusOk
        ? false
        : handleWorkingHours(countryCode);

    this.props.workingHoursHandler({
      isWithinWorkingHours,
      holidayStatusOk: statusOk,
    });
  };

  handleHolidays = async () => {
    const { countryCode } = this.props;

    let statusOk = false;
    try {
      await this.props.getUserHolidayByCountry(countryCode);
      statusOk = true;
    } finally {
      this.handleWorkingHours(statusOk);
    }
  };

  componentDidMount() {
    this.handleHolidays();
    return this.loadBills();
  }

  componentDidUpdate() {
    var customFilters = this.getFilters();
    if (JSON.stringify(customFilters) !== JSON.stringify(this.state.filters)) {
      this.loadBills();
    }
  }

  componentWillUnmount() {
    this.props.clearBillsList();
    this.props.setModal(true);
  }

  loadBills() {
    var customFilters = this.getFilters();
    return this.props
      .getBillsList(this.state.page, this.state.sizePerPage, customFilters)
      .then(() => {
        this.props.setModal(false);
        this.setState({ componentReady: true, filters: customFilters });
      });
  }

  getFilters() {
    var customFilters = [...this.props.filters, ...this.state.filters];
    return customFilters;
  }

  getBillsHandler = (page, sizePerPage, paramfilters, sortFilter) => {
    this.props.setModal(true);
    return this.props
      .getBillsList(page, sizePerPage, paramfilters, sortFilter)
      .then(() => {
        this.setState({ page: page, sizePerPage: sizePerPage });
        this.props.setModal(false);
      });
  };

  render() {
    const { componentReady, page, sizePerPage, filters } = this.state;
    const {
      bills,
      totalElements,
      updateCreditLine,
      countryCode,
      t,
      isWithinWorkingHours,
      holidayStatus,
    } = this.props;

    if (!componentReady) return null;

    return bills.length > 0 ? (
      <>
        {!isWithinWorkingHours && holidayStatus && (
          <AlertBanner type="error" className="schedule-alert">
            {t(
              `invoices.errors.notInWorkingHours${
                countryCode === "PA" ? "PA" : "Cr"
              }`
            )}
          </AlertBanner>
        )}

        {!holidayStatus && (
          <AlertBanner type="error" className="schedule-alert">
            {t(
              `invoices.errors.${
                countryCode === "CR"
                  ? "holiday_request_failed_CR"
                  : "holiday_request_failed_PA"
              }`
            )}
          </AlertBanner>
        )}

        <TableBill
          data={bills}
          page={page}
          getBillsList={this.getBillsHandler}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          filters={filters}
          updateCreditLine={updateCreditLine}
          approvedTo="APPROVED"
          /*  rejectedTo="ACCEPTED" */
          needToken={true}
          mode="paid_rejected"
          updateOnSubmit={true}
        />
      </>
    ) : (
      <BlankBill />
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    bills: getBills(state),
    totalElements: getTotalElements(state),
    countryCode: getSessionCountry(state),
    holidaysByCountryCode: getHolidaysByCountry(state),
    isWithinWorkingHours: getisWithinWorkingHours(state),
    holidayStatus: getHolidayStatus(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    getUserHolidayByCountry: (payload) =>
      dispatch(getUserHolidayByCountry(payload)),
    workingHoursHandler: (payload) => dispatch(workingHoursHandler(payload)),
    getBillsList: (page, size, filters, sort) =>
      dispatch(getBillsList(page, size, filters, sort)),
    clearBillsList: (payload) => dispatch(clearBillsList(payload)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatch)(PaidRejectedList)
);
